// src/features/switch-theme/ui/SwitchTheme.tsx
'use client';
import { MoonFilled, SunFilled } from '@ant-design/icons';
import { Switch } from 'antd';
import { useUIStore } from '@/shared/store/ui.store';
import styles from './styles.module.scss';

const SwitchTheme = () => {
  const theme = useUIStore((state) => state.theme);
  const setTheme = useUIStore((state) => state.setTheme);

  const handleSwitchTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  return (
    <Switch
      className={styles.switch}
      size='small'
      onChange={handleSwitchTheme}
      checked={theme === 'dark'}
      unCheckedChildren={<SunFilled className={styles.icon} />}
      checkedChildren={<MoonFilled className={styles.icon} />}
    />
  );
};

export default SwitchTheme;
